import styled from 'styled-components';
import { COLORS } from '@/constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: fit-content;
  transition: all 0.2s;
`;

export const TextBox = styled.div<{ $isExpanded: boolean }>`
  max-height: ${({ $isExpanded }) => ($isExpanded ? '100%' : '200px')};
  transition: max-height 0.2s;
  overflow: hidden;
  height: 100%;

  ul,
  ol {
    margin: 8px 0;
    padding-left: 1.25em;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  li {
    margin: 4px 0;
  }

  a {
    color: ${COLORS['blue-light-2']};
  }
`;
